import { Phone, MessageSquare, ArrowRight } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { BUSINESS_INFO, SMS_LINK } from "@/data/businessInfo";
import { smsForPath, smsLink } from "@/data/serviceSms";
import { trackConversion } from "@/lib/track";
import { WALL_PRINTING_SERVICE, wallPrintingServiceForEntry } from "@/data/wallPrinting";
interface MobileStickyCTAProps { sourcePage?: string }
const MobileStickyCTA = (_props: MobileStickyCTAProps) => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin/")) return null;
  const message = smsForPath(pathname);
  const estimateHref = wallPrintingServiceForEntry(pathname) ? `/contact/?service=${encodeURIComponent(WALL_PRINTING_SERVICE)}#estimate-form` : "/contact/";
  return <nav aria-label="Quick project contact" className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-background/95 backdrop-blur-md border-t border-border safe-area-bottom">
    <div className="grid grid-cols-3 gap-2 p-3">
      <Button asChild variant="outline" className="px-1 gap-1 !tracking-normal !text-[11px] min-h-12"><a href={BUSINESS_INFO.phoneLink} onClick={() => trackConversion("phone_click", { location: "mobile_sticky_bar" })}><Phone className="h-3.5 w-3.5" />Call</a></Button>
      <Button asChild variant="outline" className="px-1 gap-1 !tracking-normal !text-[11px] min-h-12"><a href={message ? smsLink(message) : SMS_LINK} onClick={() => trackConversion("text_click", { location: "mobile_sticky_bar" })}><MessageSquare className="h-3.5 w-3.5" />Text Photos</a></Button>
      <Button asChild className="px-1 gap-1 !tracking-normal !text-[11px] min-h-12"><Link to={estimateHref}><ArrowRight className="h-3.5 w-3.5" />Get Estimate</Link></Button>
    </div>
  </nav>;
};
export default MobileStickyCTA;
